import {
    GET_USER_VALID,
    GET_MY_REQUEST_SHC,
    GET_MY_REQUEST_STATUS,
    GET_AGENDAS,
    GET_AGENDAS2,
    ADD_REQUEST,
    ADD_BASE64,
    SHC_LOADING,
    SHC_LOADING_INI,
    GET_EMPLO_STATUS
  } from "../actions/ScheduleChangeAction";
  
  
  const initialState = {
    UserValid: true,
    MyRequest: [],
    MyRequestStatus: '',
    Agendas: [],
    Agendas2: [],
    addRequestID: 0,
    loading: false,
    loadingini : false,
    add: false,
    addBase64: false,
    EmploStatus:[]
  };

  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case SHC_LOADING: {
          return {
            ...state,
            loading: true,
            loadingini: false,
            add: false,
            addBase64 :false,
          };
        }
        case SHC_LOADING_INI: {
            return {
              ...state,
              loading: false,
              loadingini: true,
              add: false,
              addBase64 :false,
            };
          }
        case GET_USER_VALID: {
            return{
                ...state,
                UserValid : action.data,
                loading: false,
                loadingini: false,
                add : false,
                addBase64 :false,
            }
        }
        case GET_EMPLO_STATUS :{
          return{
            ...state,
                EmploStatus : action.data,
                loading: false,
                loadingini: false,
                add : false,
                addBase64 :false,
          }
        }
        case GET_MY_REQUEST_SHC: {
            return{
                ...state,
                MyRequest :  [...action.data],
                loading: false,
                loadingini: false,
                add : false,
                addBase64 :false,
            }
        }
        case GET_MY_REQUEST_STATUS: {
          return{
              ...state,
              MyRequestStatus :  [...action.data],
              loading: false,
              loadingini: false,
              add : false,
              addBase64 :false,
          }
      }
        case GET_AGENDAS: {
          return{
              ...state,
              Agendas :  [...action.data],
              loading: false,
              loadingini: false,
              add : false,
              addBase64 :false,
          }
      }
      case GET_AGENDAS2: {
        return{
            ...state,
            Agendas2 :  [...action.data],
            loading: false,
            loadingini: false,
            add : false,
            addBase64 :false,
        }
    }
      case ADD_REQUEST: {
        return{
          ...state,
          addRequestID : action.data,
          loading: false,
          loadingini: false,
          add : true,
          addBase64 :false,
        }
      }
      case ADD_BASE64:{
        return{
          ...state,
          addBase64 : true,
          loading: false,
          loadingini: false,
          add : false,
        }
      }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  